<div class="d-flex flex-wrap">
    <div class="flex-wrap pr-5" *ngFor="let param of parametros"
         [class.instrumentoFinanceiro]="param.label == 'Instrumento financeiro'">
        <div class="d-flex flex-row">
            <div *ngIf="param.tipo !=='COMPOSTO'" class="mb-3 mr-3">{{param.label}}:</div>
            <div *ngIf="param.tipo === 'VALOR_FINANCEIRO' || param.tipo === 'PERCENTUAL'" class="param-container flex-shrink-1">
                          <span class="font-weight-bold param-value" *ngIf="valores && valores[param.variavel] !== '-'">
                              {{valores[param.variavel] | number: '1.2-2':'Pt' }}
                          </span>
                <span class="font-weight-bold param-value" *ngIf="valores && valores[param.variavel] === '-'">
                              {{valores[param.variavel] }}
                          </span>
            </div>
            <div *ngIf="valores && param.tipo !== 'VALOR_FINANCEIRO' && param.tipo !== 'COMPOSTO' && param.tipo !== 'PERCENTUAL'
            && param.tipo !== 'BOOLEAN' && param.tipo !== 'MULTI_SELECT'" style="max-width: 82%" class="flex-shrink-1 mb-3 param-container">
                        <span class="font-weight-bold param-value">{{getValorItens(
                            valores[param.variavel]) | shorten: param.tamanhoMaximoExibicao :'...': false}}
                            <a class="flex-wrap" *ngIf="param.tamanhoMaximoExibicao < getValorItens(valores[param.variavel]).length"
                               (click)="verMais(param,getValorItens(valores[param.variavel]).length)">ver mais</a>
                <a class="flex-wrap" *ngIf="param.tamanhoMaximoExibicao == getValorItens(valores[param.variavel]).length"
                   (click)="verMenos(param)">ver menos</a>
            </span>
            </div>
            <div *ngIf="valores && param.tipo === 'COMPOSTO'" class="param-container">
              <span class="font-weight-bold param-value">{{param.label}}</span>
              <div>
                <parametro-funcao-detalhe [valores]="valores[param.variavel]" [parametros]="param.parametros"
                                          class="param-composto"></parametro-funcao-detalhe>
              </div>
            </div>
            <div *ngIf="valores && param.tipo === 'BOOLEAN'" class="param-container">
                <span class="font-weight-bold param-boolean">{{ valores[param.variavel] }}</span>
            </div>
            <div *ngIf="valores && param.tipo === 'MULTI_SELECT'" class="param-container">
                <div class="flex-shrink-1 mb-3 param-container">
            <span class="font-weight-bold param-value">{{getValorItensMultiSelect(valores[param.variavel]) | shorten: param.tamanhoMaximoExibicao :'...': false}}
                <a class="flex-wrap" *ngIf="param.tamanhoMaximoExibicao < getValorItensMultiSelect(valores[param.variavel])?.length"
                   (click)="verMais(param,getValorItensMultiSelect(valores[param.variavel]).length)">ver mais</a>
                <a class="flex-wrap" *ngIf="param.tamanhoMaximoExibicao == getValorItensMultiSelect(valores[param.variavel])?.length"
                   (click)="verMenos(param)">ver menos</a>
            </span>
                    <div class="mb-3 mr-3" style="float: right; padding-left: 15px;"> Exceto: <span class="font-weight-bold param-boolean"
                                                                                                    style="float: right; padding-left: 15px;">{{ excetoToTipoSimNao(
                        param.variavel) }}</span></div>

                </div>
            </div>
        </div>
    </div>
</div>
